export const numberFormat = new Intl.NumberFormat('es-PE');

export const moneyFormat = new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
    minimumFractionDigits: 2,
});

export const toNumber = (value) => Number(value || 0);

export const formatNumber = (value) => numberFormat.format(toNumber(value));

export const formatMoney = (value) => moneyFormat.format(toNumber(value));

export const formatOrderCode = (id) => `OS-${String(id || '').padStart(5, '0')}`;

export const percentage = (value, total) => {
    const safeTotal = toNumber(total);
    if (!safeTotal) return 0;

    return Math.round((toNumber(value) / safeTotal) * 100);
};

export const formatDate = (value) => {
    if (!value) return '-';

    let date;

    if (typeof value === 'string') {
        const raw = value.trim();

        // Sirve para:
        // 2026-05-06
        // 2026-05-06T00:00:00.000Z
        // 2026-05-06 00:00:00
        if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
            const [year, month, day] = raw.slice(0, 10).split('-').map(Number);
            date = new Date(year, month - 1, day);
        } else {
            date = new Date(raw);
        }
    } else if (value instanceof Date) {
        const year = value.getUTCFullYear();
        const month = value.getUTCMonth();
        const day = value.getUTCDate();

        date = new Date(year, month, day);
    } else {
        return '-';
    }

    if (Number.isNaN(date.getTime())) return '-';

    return new Intl.DateTimeFormat('es-PE', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).format(date);
};